import ScrollWrapper from "../../../Components/ScrollWrapper";
import Text from "../../../Components/Text";
import SmallImage from "../../../Components/SmallImage";
import ChapterToggler from "../../../Components/ChapterToggler";

const CreateOffer = () => {
    return (
        <ScrollWrapper>
            <div className="w-full h-full flex flex-col p-3 gap-4">
                <Text type="maintitle">Rabatte Verwalten</Text>

                <Text type="itemtext">
                    Rabatte werden bei Auswahl am Kassenterminal automatisch
                    auf rabattierbare Produkte angewendet.
                </Text>

                <SmallImage src={"instructions/offer-main.png"} />

                {/* Übersicht */}
                <div className="w-full flex flex-col">
                    <Text type="title">1. Neuen Rabatt erstellen</Text>
                    <Text type="title">2. Alle Rabatte</Text>
                    <Text type="title">3. Löschen</Text>
                </div>

                {/* 1. Neuen Rabatt erstellen */}
                <ChapterToggler title="1. Neuen Rabatt erstellen">
                    <Text type="itemtext">
                        Durch das Drücken auf diesen Knopf öffnet sich folgendes Formular:
                    </Text>

                    <br />

                    <SmallImage
                        src={"instructions/offer-create.png"}
                        smallSize="w-1/3"
                        subtitle="Rabatt Formular"
                    />

                    <br />

                    <Text type="itemtext">
                        Folgende Eigenschaft kann definiert werden:
                    </Text>

                    <Text type="itemtext">
                        <b>Rabatt in %:</b> Rabatt als Ganzzahl in Prozent
                    </Text>
                </ChapterToggler>

                {/* 2. Alle Rabatte */}
                <ChapterToggler title="2. Alle Rabatte">
                    <Text type="itemtext">
                        Hier werden alle aktuell vorhandenen Rabatte aufgelistet.
                    </Text>
                </ChapterToggler>

                {/* 3. Löschen */}
                <ChapterToggler title="3. Löschen">
                    <Text type="itemtext">
                        Über diesen Knopf können Rabatte gelöscht werden.
                        Gelöschte Rabatte stehen an der Kasse nicht mehr zur Verfügung.
                    </Text>
                </ChapterToggler>
            </div>
        </ScrollWrapper>
    );
};

export default CreateOffer;
